/*
 *   Copyright (c) 2021 Novumare Technologies
 *   All rights reserved.
 */
import { GETLASTPERF } from 'actions/types'
export default (state = [], action) => {
    if (action.type === GETLASTPERF) {
        return action.payload
    }
    return state;
}